import React from 'react'
import './TermsConditions.css'
import BannerComponent from '../Common-Component/BannerComponent/BannerComponent'
import InnerTermsConditions from './InnerTermsConditions/InnerTermsConditions'

function TermsConditions() {
  return (
    <section className='TermsConditions AboutUs'>
            <BannerComponent img="\assets\Images\TermsConditions\banner.png" title="Terms and Conditions" />

            <div className='container'>
                <div className='below_banner_section'>
                    <InnerTermsConditions />
                </div>
            </div>
        </section>
  )
}

export default TermsConditions
